import { api } from '../../';
import { SponsorsData } from './types';

export const sponsorsApi = api.enhanceEndpoints({ addTagTypes: ['Sponsors'] }).injectEndpoints({
  endpoints: build => ({
    getSponsorsList: build.query<SponsorsData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/sponsor?${queryString}`,
        method: 'GET',
      }),
    }),
    getSponsorsSimpleList: build.query<SponsorsData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/sponsor/simple-list?${queryString}`,
        method: 'GET',
      }),
    }),
    createSponsors: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/sponsor`,
        method: 'POST',
        body,
      }),
    }),
    updateSponsors: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/sponsor/${body.id}`,
        method: 'PATCH',
        body: body.data,
      }),
    }),
  }),
});

export const { useLazyGetSponsorsListQuery, useLazyGetSponsorsSimpleListQuery, useCreateSponsorsMutation, useUpdateSponsorsMutation } = sponsorsApi;
